import { Language } from '@yleisradio/areena-types';
import { CustomSearch } from 'types/yleHeader';
import { YleTunnusInstance } from 'types/yleTunnus';
import { isTestEnvironment } from 'utils/environment';
import logger from './logger';

export async function initializeTunnus(
  language: Language,
  config: CustomSearch
): Promise<YleTunnusInstance> {
  if (typeof window !== 'undefined' && window.yleTunnus) {
    const tunnus: YleTunnusInstance = await window.yleTunnus({
      trackingAppName: 'areena-web-items',
      initiatingApp: 'areena-web-items',
      language: language,
      returnToUrl: window.location.href,
      environment: isTestEnvironment() ? 'test' : 'production',
    });

    try {
      initGlobalHeaderWithTunnus(language, tunnus, config);
    } catch (e) {
      logger.warn(e);
    }
    return tunnus;
  } else {
    throw new Error('yleTunnus was not found in window');
  }
}

const initGlobalHeaderWithTunnus = (
  language: Language,
  tunnus: YleTunnusInstance,
  config: CustomSearch
) => {
  if (!window.yleHeader) {
    throw new Error('window.yleHeader is not defined');
  }
  window.yleHeader({
    language: language,
    tunnus: tunnus,
    autocomplete: config,
  });
};
